import React, { useState } from 'react';
import AddNewStudentsCourse from './dialogs/add-new-student-to-course/components/add-new-students.course';
import globalCourseStore from '../../../stores/global-course-store';
import { UserSummaryType } from '../../../api/types/user/user-summary.type';
import { Dialog } from 'primereact/dialog';
import AddStudentsToCourseDialog from './dialogs/add-new-student-to-course/add-students-to-course';
import { DataTable, DataTableRowClickEvent } from 'primereact/datatable';
import { Column } from 'primereact/column';
import dateUtils from '../../../utils/date-format';
import { Button } from 'primereact/button';
import { UserAvatarSmall } from '../../../component/user-avatar/user-avatar-small';
import globalProgramStore from '../../../stores/program-store';
import { deleteStudentOperation } from './operations/delete-student-operation';
import { Dropdown } from 'primereact/dropdown';
import appApi from '../../../api/app-api';
import { observer } from 'mobx-react-lite';
import globalSettingsStores from '../../../stores/settings-stores';
import { UserSummeryAttendance } from '../../../api/types/programs/course/course-details.type';
import { UserPageDialog } from '../../../component/ui/search-users/user-page-dialog/user-page-dialog';
import { UserType } from '../../../api/types/user/user-type';
import { PhoneNumberComponent } from '../../../utils/international-to-israeli';
import { handleExportCourseStudentsToExcel } from './operations/export-course-students-to-excel-operation';
import {
  OutlookMailDialog,
  OutlookMailDialogUser,
} from '../../../component/outlook-mail-dialog/outlook-mail-dialog';
import { ExportStudentAttendanceDialog } from './dialogs/export-student-attendance-dialog';

export interface ProgramCoursePageStudentsTabDatamodel {
  isProfessor: boolean;
}

const ProgramCoursePageStudentsTab: React.FC<ProgramCoursePageStudentsTabDatamodel> =
  observer(({ isProfessor }) => {
    const [addStudentIsActive, setAddStudentIsActive] = useState(false);
    const [userIdLoading, setUserIdLoading] = useState<number | null>(null);
    const [statusLoading, setStatusLoading] = useState<number | null>(null);
    const [selectedStudents, setSelectedStudents] = useState<UserSummaryType[]>(
      [],
    );
    const [selectedUserForDialog, setSelectedUserForDialog] = useState<
      UserSummaryType | undefined
    >();
    const [showOutlookDialog, setShowOutlookDialog] = useState(false);
    const [showExportAttendanceDialog, setShowExportAttendanceDialog] =
      useState(false);

    const closeDialog = () => {
      setAddStudentIsActive(false);
    };

    const handleUserClick = (user: UserSummaryType) => {
      setSelectedUserForDialog(user);
    };

    const closeUserDialog = () => {
      setSelectedUserForDialog(undefined);
    };

    const handleStudentDelete = async (userId: number) => {
      const currentProgramId = globalProgramStore.getCurrentId();
      const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;

      await deleteStudentOperation(
        currentProgramId,
        currentCourseId,
        userId,
        setUserIdLoading,
      );
    };

    const handleStatusChange = async (
      statusId: number,
      statusName: string,
      userId: number,
    ) => {
      try {
        setStatusLoading(userId);
        const currentProgramId = globalProgramStore.getCurrentId();
        const currentCourseId =
          globalCourseStore.getCurrentCourse()?.metadata.id;

        if (!currentProgramId || !currentCourseId) return;

        await appApi.updateCourseStudentStatus(
          currentProgramId,
          currentCourseId,
          userId,
          statusId,
        );

        // Update the local state after successful API call
        const students = globalCourseStore.courses.get(
          globalCourseStore.currentId!,
        )!.details?.students;
        if (students) {
          const updatedStudents = students.map((student) => {
            if (student.id === userId) {
              return {
                ...student,
                settingsCourseStatusId: statusId,
                settingsCourseStatusName: statusName,
              };
            }
            return student;
          });

          // Update the students array in the store
          globalCourseStore.courses.get(
            globalCourseStore.currentId!,
          )!.details!.students = updatedStudents;
        }
      } catch (error) {
        console.error('Failed to update student status:', error);
      } finally {
        setStatusLoading(null);
      }
    };

    const currentCourseMetadata =
      globalCourseStore.getCurrentCourse()?.metadata;
    const asd2 = globalSettingsStores.courseStudentStatuses;

    const statusBodyTemplate = (rowData: UserSummeryAttendance) => {
      return (
        <Dropdown
          value={rowData.settingsCourseStatusId}
          options={globalSettingsStores.courseStudentStatuses}
          style={{ height: '36px', width: '200px', alignItems: 'center' }}
          optionLabel="statusName"
          optionValue="id"
          onChange={(e) =>
            handleStatusChange(
              e.value,
              globalSettingsStores.courseStudentStatuses.find(
                (status) => status.id === e.value,
              )?.statusName ?? '',
              rowData.id,
            )
          }
          disabled={statusLoading === rowData.id}
          placeholder="בחר סטטוס"
        />
      );
    };

    const calculateRelationAttendanceInCourse = (
      occurredAttendance: number,
      occurredLecture: number,
    ) => {
      const lecturesLength =
        globalCourseStore.getCurrentCourse()?.details?.lectures.length;

      const attendedNumber: number = occurredLecture * occurredAttendance;
      return lecturesLength > 0
        ? `${(attendedNumber / lecturesLength).toFixed(1)}%`
        : 0;
    };

    const students =
      globalCourseStore.courses.get(globalCourseStore.currentId!)!.details!
        .students || [];

    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '16px',
            marginBottom: '8px',
          }}
        >
          <label style={{ fontSize: '14px', color: '#495057' }}>
            מספר שורות: {students.length}
          </label>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <Button
              icon="pi pi-plus"
              style={{ height: '30px', width: '30px' }}
              onClick={() => setAddStudentIsActive(true)}
              visible={!isProfessor}
              tooltip="להוספת סטודנטים"
              /*label={'להוספה'}*/
            />
            <Button
              style={{
                height: '30px',
                width: '30px',
                backgroundColor: '#10b981',
                borderColor: '#10b981',
              }}
              icon="pi pi-file-excel"
              tooltip="ייצוא נוכחות לסטודנטים"
              onClick={() => setShowExportAttendanceDialog(true)}
            />
            <Button
              style={{
                height: '30px',
                width: '30px',
                backgroundColor: '#0078d4',
                borderColor: '#0078d4',
              }}
              icon="pi pi-envelope"
              tooltip="ייצוא לאאוטלוק"
              onClick={() => setShowOutlookDialog(true)}
            />
            <Button
              style={{
                height: '30px',
                width: '30px',
                backgroundColor: '#10b981',
                borderColor: '#10b981',
              }}
              icon="pi pi-file-excel"
              tooltip="ייצוא לאקסל"
              onClick={() => handleExportCourseStudentsToExcel(students)}
            />
          </div>
        </div>

        <DataTable
          emptyMessage={
            <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
          }
          selectionMode={'multiple'}
          selection={selectedStudents}
          onSelectionChange={(e) => setSelectedStudents(e.value)}
          multiple={true}
          groupRowsBy="dsf"
          value={students}
          onRowClick={(e: DataTableRowClickEvent) => {
            handleUserClick(e.data as UserSummaryType);
          }}
          dataKey="id"
          tableStyle={{
            direction: 'rtl',
            marginTop: '16px',
          }}
          className="clickable-rows"
        >
          <Column
            style={{ textAlign: 'right', width: '50px' }}
            field="lastName"
            header=""
            body={(rowData) => (
              <UserAvatarSmall
                imageUrl={rowData?.fileUrl}
                firstName={rowData?.firstName}
                lastName={rowData?.lastName}
              />
            )}
          />
          <Column
            style={{ textAlign: 'right', width: '150px' }}
            field="firstName"
            header="שם"
            body={(rowData) => (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <label style={{ fontWeight: 'bold' }}>
                  {rowData.lastName} {rowData.firstName}
                </label>
              </div>
            )}
          />

          <Column
            style={{ textAlign: 'right' }}
            field="nationalId"
            header="ת.ז"
          />

          <Column
            style={{ textAlign: 'right', width: '150px' }}
            field="phoneNumber"
            header="טלפון"
            body={(rowData: UserSummaryType) => (
              <PhoneNumberComponent phoneNumber={rowData.phoneNumber} />
            )}
          />

          <Column
            style={{ textAlign: 'right' }}
            field="firstName"
            header="תאריך לידה"
            body={(rowData: UserSummaryType) => (
              <div>
                {rowData.dateOfBirth
                  ? dateUtils.displayFormatDate(rowData.dateOfBirth)
                  : 'לא קיים'}
              </div>
            )}
          />

          <Column style={{ textAlign: 'right' }} field="email" header="מייל" />

          <Column
            style={{ textAlign: 'right' }}
            field="courseStatusId"
            header="סטטוס"
            body={statusBodyTemplate}
          />

          <Column
            style={{ textAlign: 'right' }}
            field="attendancePercentage"
            header="אחוז נוכחות יחסי"
            body={(rowData: UserSummeryAttendance) =>
              rowData.attendancePercentage !== null &&
              rowData.attendancePercentage !== undefined
                ? `${rowData.attendancePercentage.toFixed(1)}%`
                : 'טרם הוזנו נתונים'
            }
          />
          <Column
            style={{ textAlign: 'right' }}
            field="asd"
            header="אחוז נוכחות מוחלט"
            body={(rowData: UserSummeryAttendance) =>
              rowData.attendancePercentage !== null &&
              rowData.attendancePercentage !== undefined &&
              rowData.courseTotalRequiredLectures !== null &&
              rowData.courseTotalRequiredLectures !== undefined
                ? calculateRelationAttendanceInCourse(
                    rowData.attendancePercentage,
                    rowData.courseTotalRequiredLectures,
                  )
                : 'טרם הוזנו נתונים'
            }
          />

          <Column
            style={{ textAlign: 'right' }}
            field="finalGrade"
            header="ציון סופי"
          />

          <Column
            style={{ textAlign: 'right' }}
            field="נשלח ע״י"
            header=""
            body={(rowData: UserSummaryType) => (
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'הסרת סטודנט מהקורס'}
                loading={userIdLoading === rowData.id}
                disabled={userIdLoading !== null}
                onClick={() => handleStudentDelete(rowData.id)}
              />
            )}
          />
        </DataTable>

        <AddStudentsToCourseDialog
          visible={addStudentIsActive}
          onHide={() => setAddStudentIsActive(false)}
          courseMetadata={currentCourseMetadata}
          closeDialog={closeDialog}
        />

        <UserPageDialog
          userRole={UserType.STUDENT}
          selectedUser={selectedUserForDialog}
          setSelectedUser={setSelectedUserForDialog}
          closeDialog={closeUserDialog}
          onHide={closeUserDialog}
        />

        <OutlookMailDialog
          visible={showOutlookDialog}
          onHide={() => setShowOutlookDialog(false)}
          users={students.map(
            (s): OutlookMailDialogUser => ({
              userId: s.id,
              firstName: s.firstName,
              lastName: s.lastName,
              nationalId: s.nationalId,
              mail: s.email,
            }),
          )}
          title={`ייצוא לאאוטלוק - ${currentCourseMetadata?.abstractData?.courseName || 'קורס'}`}
        />

        <ExportStudentAttendanceDialog
          visible={showExportAttendanceDialog}
          onHide={() => setShowExportAttendanceDialog(false)}
        />
      </div>
    );
  });

export default ProgramCoursePageStudentsTab;
